// extracted by mini-css-extract-plugin
module.exports = {"realtor_card":"styles_realtor_card__QAkJo","two_agents":"styles_two_agents__BDKrN"};